"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var MenuListItemWrapper_1 = require("./MenuListItemWrapper");
var MenuList = function (_a) {
    var menuItem = _a.menuItem, isProdMenu = _a.isProdMenu, shopAllMenu = _a.shopAllMenu, noTitle = _a.noTitle, className = _a.className;
    var menuToRender = menuItem.items;
    if (isProdMenu) {
        //   // Filter menuItem.items by link type == PAGE | HTTP.
        //   // Because menuItem.items may also contain type == product,
        //   // but we don't want to render those.
        //   // E.g.,
        //   // PAGE: for review page (render)
        //   // HTTP: for collection page shop section hash link (render)
        //   // PRODUCT: for showing the collection nav on product page (do not render)
        menuToRender = menuItem.items.filter(function (item) { var _a; return (item.type === 'PAGE' && ((_a = item.url) === null || _a === void 0 ? void 0 : _a.includes('-reviews'))) || item.type === 'HTTP'; });
    }
    // Determine if the list is 'other-nav'
    var otherNav = false;
    if ('handle' in menuItem) {
        otherNav = menuItem.handle === 'other-nav';
    }
    return ((0, preact_1.h)("div", { class: "menu-list ".concat(className || '') },
        !noTitle && (0, preact_1.h)("p", { class: "menu-list__title" }, menuItem.title.replace('| ', '')),
        (0, preact_1.h)("div", { class: "menu-list__body" }, menuToRender.map(function (childMenuItem) { return ((0, preact_1.h)(MenuListItemWrapper_1.default, { menuItem: childMenuItem, otherNav: otherNav, key: childMenuItem.id })); })),
        shopAllMenu && ((0, preact_1.h)("div", { class: "menu-list__body" }, shopAllMenu.items.map(function (childMenuItem) { return ((0, preact_1.h)(MenuListItemWrapper_1.default, { menuItem: childMenuItem, key: childMenuItem.id })); })))));
};
exports.default = MenuList;
